<template>
	<div>
        <div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Nome *</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.nome"
		        	:id="name+'nome'"
		        	@input="clearValidation('nome')">
		        <div class="invalid-feedback" :id="name+'nome-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-4">
		        <label>Valor *</label>
                <money
                    :id="name+'valor'"
                    class="form-control"
                    v-model="dados.valor"
                    @input="calcularCustoProduto(); clearValidation('valor')">
                </money>
		        <div class="invalid-feedback" :id="name+'valor-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Quantidade de produtos</label>
		        <input
		        	type="number"
		        	class="form-control"
		        	v-model="dados.quantidade_produtos"
		        	:id="name+'quantidade_produtos'"
		        	@input="calcularCustoProduto(); clearValidation('quantidade_produtos')">
		        <div class="invalid-feedback" :id="name+'quantidade_produtos-invalid-feedback'"></div>
		    </div>
            <div class="form-group col-md-4">
		        <label>Custo por produto</label>
				<money
                    class="form-control"
                    v-model="dados.valor_por_produto"
					disabled>
                </money>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados),
			}
		},
		methods : {
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			},
			calcularCustoProduto(){
				if(this.dados.valor && this.dados.quantidade_produtos){
					this.dados.valor_por_produto = this.dados.valor / this.dados.quantidade_produtos;
				} else {
					this.dados.valor_por_produto = 0;
				}
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
